<script>
import cloneDeep from 'lodash/cloneDeep';
import { mask } from 'vue-the-mask';

export default {
  components: {},
  directives: { mask },
  props: {
    text: {
      type: String,
      required: true,
      default: null,
    },
    placeholderTxt: {
      type: String,
      required: false,
      default: '',
    },
    mode: {
      type: String,
      required: false,
      default: null,
    },
    color: {
      type: String,
      required: false,
      default: null,
    },
    canEdit: {
      type: Boolean,
      required: false,
    },
    inputMask: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      editing: false,
      initialText: '',
      inputText: this.text,
    };
  },
  computed: {},
  mounted() {
    this.initialText = this.text;
  },
  watch: {
    inputText(val) {
      this.$emit('update-editable-value', val);
    },
  },
  methods: {
    toggleEdit() {
      this.editing = true;
      setTimeout(() => this.$refs.inlineEditInput.focus());
    },
    validate(evt) {
      this.editing = false;
      if (evt.target.value === '') {
        this.text = cloneDeep(this.initialText);
      }
    },
  },
};
</script>

<template>
  <span>
    <span
      :class="['inline-text', { 'edit-disabled': !canEdit }]"
      v-show="!editing && mode !== 'edit'"
      @click="toggleEdit"
    >
      {{ text }}
    </span>
    <input
      v-show="editing || mode === 'edit'"
      v-if="inputMask"
      v-mask="inputMask"
      type="text"
      ref="inlineEditInput"
      :disabled="!canEdit"
      :class="['input-inline-edit', { lightTxt: color }]"
      v-model="inputText"
      :placeholder="placeholderTxt"
      @keydown.enter="editing = false"
      @blur="validate"
    />
    <input
      v-show="editing || mode === 'edit'"
      v-else
      type="text"
      ref="inlineEditInput"
      :disabled="!canEdit"
      :class="['input-inline-edit', { lightTxt: color }]"
      v-model="inputText"
      :placeholder="placeholderTxt"
      @keydown.enter="editing = false"
      @blur="validate"
    />
  </span>
</template>

<style lang="scss" scoped>
@import '@design';

.inline-text {
  &.edit-disabled {
    cursor: default;
  }
}

.input-inline-edit {
  background: transparent;
  border: 0;
  border-bottom: 1px solid $color-border-light-gray;
  font-size: 4.8rem;
  font-weight: 900;
  letter-spacing: -0.761905px;
  line-height: 5.2rem;
  padding: 0;
  transition: border-bottom $duration-animation-base ease-in-out;
  width: 100%;

  &:focus {
    border-bottom: 1px solid $color-border-light-gray;
    outline: none;
  }

  &:disabled {
    border-bottom: none;
    color: initial;
    outline: none;
  }

  &.lightTxt {
    color: $color-off-white;
  }
}
</style>
